/**
 * TopMenu
 * @module components/TopMenu
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './TopMenu.scss';

import { I18nContext } from 'context/i18n.context';
import Link from 'common/Link/Link';
import Icon from 'components/Icon';
import { DropDown, DropDownItem, DropDownTitle, DropDownList } from 'components/DropDown';
import FavoritesList from 'components/FavoritesList';

/** Class representing the component. */
class TopMenu extends Component {

	static contextType = I18nContext;

	constructor(props) {
		super(props);

		this.state = {
			icon: 'icon-angle-down',
			clientSide: false
		};
	}

	componentDidMount() {
		this.setState({ clientSide: true });
	}

	/**
	 * Gets the navigational links
	 */
	getLinks () {
		const links = this.props.links || [];
		
		return links.map((link, i) =>
			<li className={style.item} key={link.title}>
				<Link route={link.href}>
					<a className={style.topLink} dangerouslySetInnerHTML={{ __html: link.title }}></a>
				</Link>
			</li>
		);
	}


	/**
	 * Gets title of the current language.
	 * @param {String} currentLanguage
	 * @param {Array} languages
	 */
	getCurrentLanguageTitle (currentLanguage, languages) {
		let title = '';

		languages.forEach(item => {
			if (item.language == currentLanguage) {
				title = item.title;
			}
		});

		return title;
	}


	/**
	 * Renders a Google Translate dropdown
	 */
	renderGoogleTranslate() {
		return (
			<li className={style.translate}>
				<span>Google Translate</span>
				<div id="google-translate-dropdown" className="dropdown dropdown-large dropdown-right">
					<p>Use Google to translate the web site. We take no responsibility for the accuracy of the translation.</p>
					<span id="google_translate_element"></span>
				</div>
			</li>
		);
	}


	/**
	 * The render method
	 */
	render () {
		const { currentLanguage, languages } = this.context;
		return (
			<nav className={style.topMenu} aria-label="Top menu">
				<ul className={style.list}>
					<li className={`${style.item}`} key="My favorites">
						<FavoritesList />
					</li>

					{ this.getLinks() }

					<li
						className={`${style.item} ${style.dropDown}`}
						onMouseLeave={() => this.setState({ icon: 'icon-angle-down' })}
						key="Languages">
						<DropDown>
							<DropDownTitle>
								<Icon icon="icon-globe" color="red" />
								<span className={style.bold} onMouseOver={() => this.setState({ icon: 'icon-angle-up' })}>
									{this.getCurrentLanguageTitle(currentLanguage, languages)}
								</span>
								<Icon icon={this.state.icon} />
							</DropDownTitle>

							<DropDownList>
								{ languages.map((item, i) => {
									return (
										<DropDownItem key={i} href={item.href} external={true}>
											{item.title}
										</DropDownItem>
									);
								}) }
								{this.state.clientSide && window.matchMedia('(min-width: 769px)').matches && this.renderGoogleTranslate()}
							</DropDownList>
						</DropDown>
					</li>
				</ul>
			</nav>
		);
	}
}


/** Prop types **/
TopMenu.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			href: PropTypes.string
		})
	),
	languages: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			href: PropTypes.string,
			language: PropTypes.string
		})
	)
};


export default TopMenu;
